import React, { useEffect, useState } from 'react'
import axios from 'axios'

import CardScreen from 'screens/CardScreen'

export default function TermsOfService() {
  const [content, setContent] = useState('')

  useEffect(() => {
    ;(async () => {
      const { data } = await axios.get('/TermsOfService.html')

      setContent(data)
    })()
  }, [])

  return (
    <CardScreen size="md">
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </CardScreen>
  )
}
